export const createNestedParts = (parts) => {
  // Guard clause: return empty array if parts is not a valid array
  if (!parts || !Array.isArray(parts)) {
    return [];
  }

  const partsCopy = [...parts];
  const partsMap = new Map(partsCopy.map(part => [part.id, { ...part, children: [] }]));
  let rootParts = [];
  partsCopy.forEach(part => {
    if (part.parent_id) {
      const parentPart = partsMap.get(part.parent_id);
      if (parentPart) {
        parentPart.children.push(partsMap.get(part.id));
      }
    } else {
      rootParts.push(partsMap.get(part.id));
    }
  });
  return rootParts;
};
